import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import {
  Grid,
  IconButton,
  Tooltip,
  Typography,
  withStyles,
  Link,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { shape, string } from 'prop-types';

import getDateTime from '../../../../../utils/datetime';
import { getI18n } from '../../../../../utils/intl';
import styles from './styles';
import { KEY_STORE_TYPE_OTK } from "../../../../../constants";
import { lowerCase, startCase } from "lodash";

export const Footer = ({
  classes = {},
  id,
  deploymentType,
  tooltip,
  lastUpdated,
  keyStoreDetails,
}) => {
  const intl = getI18n(useIntl());
  return (
    <Grid container className={classes.type}>
      {keyStoreDetails &&
        <Grid
          item md={6} sm={6} xs={6}
          id={`${id}-key-store-container`}
          data-layer7-test={`${id}-key-store-container`}
          className={classes.keyStoreContainer}
        >
          <Fragment>
            <Typography variant="h5" className={classes.keyStoreLabel}>
              {intl.getI18nMessage('label.key.store.name')}
            </Typography>
            <Typography variant="body1">
            <Link href={`/admin/key-stores/details/${keyStoreDetails.uuid}`}>
              {keyStoreDetails.name}
            </Link>
            </Typography>
          </Fragment>
        </Grid>
      }
      {keyStoreDetails &&
        <Grid
          item md={6} sm={6} xs={6}
          id={`${id}-key-store-type-container`}
          data-layer7-test={`${id}-key-store-type-container`}
          className={classes.keyStoreContainer}
        >
          <Fragment>
            <Typography variant="h5" className={classes.keyStoreLabel}>
              {intl.getI18nMessage('label.key.store.type')}
            </Typography>
            <Typography variant="body1">
              {(keyStoreDetails.keyStoreType === KEY_STORE_TYPE_OTK)
                ? keyStoreDetails.keyStoreType :
                startCase(lowerCase(keyStoreDetails.keyStoreType))}
            </Typography>
          </Fragment>
        </Grid>
      }
      {deploymentType &&
        <Grid
          item md={6} sm={6} xs={12}
          id={`${id}-status-type`} data-layer7-test={`${id}-status-type`}
        >
          <Grid container>
            <Grid item>
              <Typography variant="h5" className={classes.footerLabel}>
                {intl.getI18nMessage('label.proxy.details.page.overview.deployment.type')}
              </Typography>
            </Grid>
            {tooltip &&
              <Tooltip arrow placement="right" title={tooltip} >
                <IconButton
                  size="small" edge="start" color="secondary"
                  className={classes.helpIcon}
                  aria-label={`${id}-help`}
                >
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            }
          </Grid>
          <Typography variant="body1">
            {deploymentType}
          </Typography>
        </Grid>
      }
      <Grid
        item md={6} sm={6} xs={12}
        id={`${id}-status-updated`}
        data-layer7-test={`${id}-status-updated`}
        className={lastUpdated ? classes.footerContainer : ''}
      >
        {lastUpdated &&
          <Fragment>
            <Typography variant="h5" className={classes.footerLabel}>
              {intl.getI18nMessage('label.last.updated')}
            </Typography>
            <Typography variant="body1">
              {getDateTime(lastUpdated)}
            </Typography>
          </Fragment>
        }
      </Grid>
    </Grid>
  );
}

Footer.propTypes = {
  classes: shape({}),
  id: string,
  deploymentType: string,
  lastUpdated: string,
  tooltip: string,
  keyStoreDetails: shape({}),
};
Footer.displayName = 'Footer';

export default (
  withStyles(styles)
)(Footer);
